import { getHomeSummaryV25 } from '../api';
import * as actionTypes from './actionTypes';

export const enregistrerAccueilSummary = (summary) => ({
  type: actionTypes.ENREGISTRER_ACCUEIL_SUMMARY,
  summary,
});

export const reqRecupererAccueilSummary = () => {
  return async (dispatch) => {
    try {
      const response = await getHomeSummaryV25();
      if (response?.data?.state) {
        dispatch(enregistrerAccueilSummary(response.data));
      }
    } catch (err) {
      console.error('Erreur getHomeSummaryV25', err);
    }
  };
};
